import classNames from 'classnames'
import React, { PureComponent } from 'react'

import './loading-modal.scss'
import ContentBlock from '../content-block'
import DoubleBounceSpinner from '../double-bounce-spinner'
import Modal from '../modal'

export type Props = {
  className?: string
  content?: string
}

export default class LoadingModal extends PureComponent<Props> {
  render() {
    const { className, content } = this.props

    return (
      <Modal className={classNames('amp-loading-modal', className)}>
        <DoubleBounceSpinner />
        {content && <ContentBlock className="content">{content}</ContentBlock>}
      </Modal>
    )
  }
}
